module.exports = __webpack_public_path__ + "img/lr-cb66-r1-3p.e2137373.gif";